

<div class="min-h-screen flex flex-col">
    <div class="flex-1 flex items-center justify-center pt-30 sm:p-8 sm:pt-30">
        <!-- <div class="w-full max-w-5xl bg-white/70 dark:bg-gray-950/70 border border-slate-300/70 dark:border-slate-100/70 rounded-xl shadow-sm"> -->
        <div class="w-full max-w-5xl bg-white dark:bg-gray-950 border border-slate-300 dark:border-slate-100 rounded-xl shadow-sm">
            <!-- HEADER -->
            <order-wizard-header></order-wizard-header>

            <!-- CONTENT SCROLLABLE -->
            <!-- <div class="px-2 md:px-10 py-2 md:py-8 min-h-[240px] transition-all duration-200"> -->
            <div class="px-2 md:px-5 pt-5 h-[60vh] overflow-hidden">
                <div
                    class="h-full flex flex-col transition-[opacity,transform] duration-500 ease-[cubic-bezier(0.22,1,0.36,1)]"
                    [ngClass]="{
                    'opacity-0 -translate-x-0': _orderWizardNavigationService.animating && (_orderWizardNavigationService.direction === 'forward' || _orderWizardNavigationService.direction === 'backward'),
                    'opacity-100 translate-x-0': _orderWizardNavigationService.animating==false
                    }"
                >

                @if(_orderWizardNavigationService.activeStep() === 0){
                    <!-- <order-wizard-payment-success></order-wizard-payment-success> -->
                    <order-wizard-purchase class="h-full"></order-wizard-purchase>
                }
                @if(_orderWizardNavigationService.activeStep() === 1){
                    <order-wizard-pickup-point class="h-full"></order-wizard-pickup-point>
                }
                @if(_orderWizardNavigationService.activeStep() === 2){
                    <order-wizard-identification class="h-full"></order-wizard-identification>
                }
                @if(_orderWizardNavigationService.activeStep() === 3){
                    <order-wizard-due-diligence class="h-full"></order-wizard-due-diligence>
                } 
                @if(_orderWizardNavigationService.activeStep() === 4){
                    <order-wizard-term-and-condition class="h-full"></order-wizard-term-and-condition>
                }   
                @if(_orderWizardNavigationService.activeStep() === 5){
                    <!-- <order-wizard-payment-success class="h-full"></order-wizard-payment-success> -->
                    <order-wizard-summary class="h-full"></order-wizard-summary>
                }     
            </div>
            </div>
            <!-- FOOTER FIXE -->
            <order-wizard-footer></order-wizard-footer>
   
        </div>
    </div>
</div>

























